// Lightweight GA4 event helper. Safe no-op if gtag has not loaded.
// PDF downloads are also logged to our own backend so the Admin counters include them.
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    /* analytics must never break the app */
  }
  if (name === 'pdf_download') trackServerEvent('pdf_download', { contentType: params.type, title: params.title });
};

// In-house analytics: log Share and PDF download events to our own backend so
// they are captured even when ad blockers or lack of cookie consent block GA4.
// Fire-and-forget; never blocks or breaks the app.
export const trackServerEvent = (eventType, { contentType, title } = {}) => {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    fetch(`${base}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        event_type: eventType,
        content_type: contentType,
        title,
        path: typeof window !== 'undefined' ? window.location.pathname : '',
      }),
    }).catch(() => {});
  } catch (e) {
    /* analytics must never break the app */
  }
};
